import React, { useEffect, useState } from 'react';
import AboutUsTabs from '../AboutUsTabs/AboutUsTabs';
import beachworkout1 from '../../Assets/images/About/beachworkout1.jpg';
import beachworkout2 from '../../Assets/images/About/beachworkout2.jpg';
import vinodhImage from '../../Assets/images/About/Vinodh.jpg';
import { Grid2, useMediaQuery } from '@mui/material';
import getStyles from './styles';
const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const {
    container = {},
    heading = {},
    subheading = {},
    paragraph = {},
    list = {},
    listItem = {},
    images = {}
  } = getStyles({ isMobile, isVisible });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300); // Delay before the animation starts
    return () => clearTimeout(timer);
  }, []);

  const tabData = [
    <>
      <p style={paragraph}>
        Inspired by the likes of ancestral farming and military training, we
        created a unique approach to fitness that focuses on natural food and
        community-driven workouts. Our commitment to discipline, punctuality,
        and fun sets us apart from traditional gyms.
      </p>
      <>
        <h3 style={subheading}>About Vinodh</h3>
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
            <img src={vinodhImage} alt="Vinodh" style={images} />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
            <p style={paragraph}>
              {`Vinodh's journey into fitness began in 2005 when he started working out
        with friends for fun. What started as a casual activity quickly turned
        into a passion fueled by competition and comparison. In 2006, he
        participated in his first gym competition, where he placed second and
        realized this was his true calling. Inspired by fitness legends like
        Arnold Schwarzenegger and Dexter Jackson, he immersed himself in
        bodybuilding, training hard for titles such as Mr. Chennai and Mr. Tamil
        Nadu.`}
            </p>
          </Grid2>
        </Grid2>
        <p style={paragraph}>
          Building on a solid fitness foundation, his professional path included
          working as a trainer in hotels and various gyms, where he engaged with
          a wide range of clients from different backgrounds. As a celebrity
          trainer, Vinodh has had the honor of training well-known figures like
          Arun Vijay, Mahath, STR, Akshara Reddy, Aishwarya Dhutta, Shirish,
          Atharva, Niroop Nandakumar, Priyanka Deshpande, and many others. With
          his vast experience and knowledge, Vinodh is committed to helping
          others reach their fitness goals and embrace a healthier lifestyle.
        </p>
      </>
    </>,
    <>
      <Grid2 container alignItems={'center'}>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <img src={beachworkout2} alt="beachworkout2" style={images} />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <p style={paragraph}>
            {`At BeatXFit, our vision is to cultivate a thriving community where every individual, regardless of background or ability, is empowered to achieve personal milestones and overcome limitations. We are more than a gym; we are a movement, a place where strength, perseverance, and camaraderie redefine the meaning of fitness. Our commitment is to provide world-class coaching, a supportive atmosphere, and cutting-edge programming that adapts to each individual, ensuring everyone can push beyond their best self, every single day.`}
          </p>
        </Grid2>
      </Grid2>
      <p style={paragraph}>
        {`BeatXFit is built on the principles of inclusivity, growth, and resilience. We believe that fitness is a journey, not a destination. Here, members aren’t just reaching new heights in their physical abilities—they’re building confidence, developing mental toughness, and embracing a lifestyle of health and purpose. We strive to be a space where the hardest moments become our most transformative, turning challenges into achievements and personal goals into community celebrations.`}
      </p>
      <p style={paragraph}>
        {`Our vision is to inspire lasting change within and beyond our walls, fostering a positive ripple effect that elevates the lives of our members, their families, and the broader community. Together, we push limits, redefine expectations, and create a legacy of strength, health, and unity at BeatXFit.`}
      </p>
    </>,
    <>
      <Grid2 container alignItems={'center'}>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <img src={beachworkout1} alt="beachworkout1" style={images} />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <p style={paragraph}>
            {`BeatXFit is to inspire, uplift, and transform lives through functional fitness and a relentless commitment to personal growth. We aim to create an inclusive, welcoming space where individuals of all backgrounds and abilities feel empowered to conquer challenges, celebrate progress, and support one another. Through expert coaching, personalized guidance, and dynamic programming, we equip each member with the skills and confidence to push beyond perceived limits and achieve new heights of strength, endurance, and resilience.`}
          </p>
        </Grid2>
      </Grid2>
      <p style={paragraph}>
        {`
At BeatXFit, we believe that fitness is a journey of self-discovery and transformation that extends beyond the gym. By fostering a culture of integrity, accountability, and teamwork, we empower our members to develop not only physical health but also the mental grit and determination to overcome obstacles in all areas of life. We are committed to building a vibrant community that inspires positive change, champions individual success, and cultivates a shared passion for lifelong wellness and purpose.`}
      </p>
    </>,
    <>
      <ul style={list}>
        <li style={listItem}>
          <strong>Community:</strong> We believe in the power of community and
          the transformative effect of shared goals. Our workouts are designed
          to be challenging yet supportive, fostering a sense of camaraderie
          amongst our members.
        </li>
        <li style={listItem}>
          <strong>Holistic Approach:</strong> We go beyond just physical
          fitness. Our focus extends to overall well-being, emphasizing the
          importance of nutrition, mental resilience, and a balanced lifestyle.
        </li>
        <li style={listItem}>
          <strong>Fun & Engaging:</strong> We believe fitness should be
          enjoyable. Our innovative training methods, dynamic atmosphere, and
          focus on fun make working out an exciting and rewarding experience.
        </li>
        <li style={listItem}>
          <strong>Inspired by Nature:</strong> Drawing inspiration from
          ancestral farming and military training, our workouts incorporate
          natural movements and functional exercises that build strength,
          endurance, and agility.
        </li>
      </ul>
    </>
  ];

  return (
    <div id="about-us-section" style={container}>
      <h2 style={heading}>About Us</h2>
      <p style={paragraph}>
        Beat XFit was founded in July 2017 by Vinodh, a renowned fitness expert
        with a passion for bodybuilding. Our goal is to provide a holistic
        fitness experience that combines cardio, strength, and agility.
      </p>
      <AboutUsTabs tabData={tabData} />
    </div>
  );
};

export default AboutUs;
